<template>
    <form>
      <div
        class="row"
        style="
          border-bottom: 2px solid #115E67;
          margin-bottom: 10px;
          font-size: 20px;
          padding: 5px 0px 0px 5px;
          margin-top: 30px;
        "
      >
        <label style="margin: 0px">AMC Account</label>
      </div>
      <div style="border: 1px #d4d4d4 solid; padding: 20px; margin-bottom: 20px">
        <div class="form-group row col-md-12">
          <div class="form-group row col-md-12">
            <label class="col-sm-2 col-form-label text-right label-wrapper-style"
              >AMC Advertiser Name</label
            >
            <label
              v-if="profile"
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
              >{{ profile.customer_canonical_name }}</label
            >
            <label
              v-else
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
              >Not Provided</label
            >
          </div>
          <div class="form-group row col-md-12">
            <label class="col-sm-2 col-form-label text-right label-wrapper-style"
              >AMC Instance Id</label
            >
            <label
              v-if="profile"
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
              >{{ profile.instance_id }}</label
            >
            <label
              v-else
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
              >Not Provided</label
            >
          </div>
          <div class="form-group row col-md-12">
            <label class="col-sm-2 col-form-label text-right label-wrapper-style"
              >AMC Instance Name</label
            >
            <label
              v-if="profile"
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
              >{{ profile.instance_name }}</label
            >
            <label
              v-else
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
              >Not Provided</label
            >
          </div>
          <div class="form-group row col-md-12">
            <label class="col-sm-2 col-form-label text-right label-wrapper-style"
              >Active</label
            >
            <label
              v-if="profile"
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
              >{{ profile.active ? 'True' : 'False' }}</label
            >
            <label
              v-else
              class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
              >Not Provided</label
            >
          </div>
        </div>
      </div>
    </form>
  </template>
  <script>
  import moment from 'moment'
  export default {
    data() {
      return {};
    },
    props: ["profile"],
    components:{moment},
    methods: {
      moment,
      getFormattedDate(date) {
          return  moment(date).format("MM/DD/YYYY");
      },
    },
  };
  </script>